module.exports = __webpack_public_path__ + "static/img/banner_solutions_hpc.831989c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/banner_solutions_hpc.png
// module id = lt2a
// module chunks = 10